/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brief_Frail_Giraffe_EmergeInputs */

const fr_brief_frail_giraffe_emerge = /** @type {(inputs: Brief_Frail_Giraffe_EmergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un logo`)
};

/**

* @param {Brief_Frail_Giraffe_EmergeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const brief_frail_giraffe_emerge = /** @type {((inputs?: Brief_Frail_Giraffe_EmergeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brief_Frail_Giraffe_EmergeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_brief_frail_giraffe_emerge(inputs)
});